import { ROLE_BASIC } from "@/constant/permission";
// 基础配置
const basicConfig = [
  {
    name: "basicConfig",
    path: "basicConfig",
    meta: {
      is_meun: true,
      title: "基础配置",
      roles: ROLE_BASIC,
      icon: "foundation",
      path: "/basicConfig"
    },
    redirect: "/basicConfig/systemConfig",
    component: () => import("@/views/basicConfig/index.vue"),
    children: [
      {
        name: "systemConfig",
        path: "systemConfig",
        meta: {
          is_meun: true,
          roles: ROLE_BASIC,
          title: "课程体系配置",
          path: "/basicConfig/systemConfig"
        },
        redirect: "/basicConfig/systemConfig/systemIndex",
        component: () => import("@/views/basicConfig/systemConfig/index.vue"),
        children: [
          {
            path: "systemIndex",
            component: () =>
              import("@/views/basicConfig/systemConfig/systemIndex/index.vue")
          },
          {
            path: "createSystem",
            name: "create-system",
            meta: {
              title: "体系配置",
              title_value: 'system_name'
            },
            component: () =>
              import("@/views/basicConfig/systemConfig/createSystem/index.vue")
          }
        ]
      }
    ]
  }
];

export default basicConfig;
